<template>
    <div class="edc-modal">
        <SOSlotModal :modal-title="`Konfirmasi`" :modal-id="modalId" @close="back">
            <template v-slot:modal-body>
                <div style="pos">
                    <div class="m-d-20">
                        <SOInformation title="Tipe postingan diubah" myStyle="margin: 0px -40px;">
                            <template v-slot:subtitle>
                                <p class="m-d-0">
                                    Anda telah mengubah tipe <b>postingan berulang</b> menjadi
                                    <b>postingan satu kali</b>, sehingga status ini tidak akan berulang kembali.
                                </p>
                            </template>
                        </SOInformation>
                    </div>
                    <p class="m-d-8 f-16 f-c-black f-regular">
                        Anda akan memposting status melalui Whatsapp {{ getPhoneNumber }} sekarang.
                    </p>
                    <p class="m-d-8 m-t-4 m-d-8 f-16 f-regular f-c-midgrey">
                        Dikenakan biaya sebesar 250 M-coin. Ingin melanjutkan?
                    </p>
                </div>
            </template>
            <template v-slot:modal-footer
                ><div class="">
                    <div style="margin-bottom: 10px">
                        <SOButton
                            :primary="true"
                            :full="true"
                            :text="'Ya, posting sekarang'"
                            :id="`logout-device`"
                            :disable="isFetching"
                            :loading="isFetching"
                            @action="posting"
                        />
                    </div>
                    <div>
                        <SOButton
                            :outline="true"
                            :full="true"
                            :text="'Batal'"
                            :id="'batal-logout-device'"
                            :disable="isFetching"
                            :loading="isFetching"
                            @action="back"
                        />
                    </div>
                </div>
            </template>
        </SOSlotModal>
    </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import resulter from "@/store/utils/resulter";

import SOInformation from "@/so-components/global/ui/SOInformation.vue";
import SOSlotModal from "@/so-components/global/slot/SOSlotModal.vue";
import SOButton from "@/so-components/global/ui/SOButton";

import { moduleName } from "../../store/state";

export default {
    name: "ConfirmEdit",
    components: {
        SOSlotModal,
        SOButton,
        SOInformation,
    },
    data() {
        return {
            modalId: "confirm-edit",
        };
    },
    beforeRouteLeave(to, from, next) {
        this.closeModal();
        next();
    },
    mounted() {
        $(`#${this.modalId}`).modal("show");
    },
    computed: {
        ...mapGetters(moduleName, {
            isFetching: "isFetching",
            response: "response",
            dataDeviceTiny: "dataDeviceTiny",
        }),
        getPhoneNumber() {
            let { country_code, number } = this.dataDeviceTiny;

            return `+${country_code}${number}`;
        },
        getData() {
            return this.$route.params.data;
        },
    },
    methods: {
        ...mapActions({
            setFetching: `${moduleName}/setFetching`,
            setResponse: `${moduleName}/setResponse`,
            updateStatus: `${moduleName}/updateStatus`,
            getDetailTinyDevice: `${moduleName}/getDetailTinyDevice`,
            getDetailStatusTn: `${moduleName}/getDetailStatusTn`,
            getListAktivitas: `${moduleName}/getListAktivitas`,
        }),
        async back(idx = -1) {
            await this.$router.go(idx);
        },

        closeModal() {
            $(`#${this.modalId}`).modal("hide");
        },
        postedData() {
            let posted = this.getData;

            posted.senin = 0;
            posted.selasa = 0;
            posted.rabu = 0;
            posted.kamis = 0;
            posted.jumat = 0;
            posted.sabtu = 0;
            posted.minggu = 0;
            posted.jam = null;
            posted.now = 1;

            return posted;
        },
        async reloadData(iddevice) {
            await this.resetList({ target: "aktivitas" });
            await this.resetPage({ target: "storyAktif" });
            await this.getStoryAktif({ iddevice });
        },
        async posting() {
            if (this.isFetching) {
                return;
            }

            let posted = this.postedData();

            await this.updateStatus(posted)
                .then((res) => {
                    if (!res.data) {
                        this.$toast.error(res);
                    } else {
                        let { status, code, data, msg } = res.data;
                        if (status && code === 200) {
                            this.getDetailTinyDevice({ deviceId: data.iddevice });
                            this.getDetailStatusTn({ iddevice: data.iddevice, idStatus: data.idschedule });
                            this.getListAktivitas({ iddevice: data.iddevice, idStatus: data.idschedule });
                            this.setResponse(resulter.successResult(msg, data));
                            this.$toast.success(msg);
                            this.back();
                        } else {
                            this.setResponse(resulter.errorResult(msg, data));
                            this.$toast.error(msg);
                        }
                    }

                    this.setFetching(false);
                })
                .catch((e) => {
                    this.$toast.error(e);
                    this.setFetching(false);
                    this.setResponse(resulter.errorResult(e));
                });
        },
    },
};
</script>
